//React
import React, {useState} from 'react'
//MUI
import Typography from '@mui/material/Typography';


export default function RewardsHub(){
    return(
        <>
        <Typography variant="h2" align="center">Rewards Hub</Typography>
        </>
    )
}